export const createSharedLink = (secretKey: string, ref: string): string =>
  `${window.location.origin}/channels/share?secret_key=${secretKey}&ref=${ref}`

export default {
  createSharedLink,
}
